import Http from '../Http';

export class CondicionPagoService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`condicion-pago/filter?${params.toString()}`);
      return res?.data?.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`condicion-pago/delete`, row);
      return Boolean(res && !res.error);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`condicion-pago/one/${id}`);
      return res?.data ?? null;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: any) {
    try {
      const res = await Http.post(`condicion-pago/save`, data);
      return res || { error: true, errMsg: 'Error al guardar Condición de Pago' };
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: 'Error al guardar Condición de Pago' };
    }
  }
}
